<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="cosId" label="客户名称/代码" :rules="[{ required: true, message: '请选择' }]">
        <CusSelect v-model:value="editForm.cosId" placeholder="请选择" @selectData="selectData" :disabled='editForm.id'/>
      </a-form-item>

    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { customerLossCreate, updateBiLoseWarning } from '@/api/gucangSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiLoseWarningParams } from '@/typings/api/gucangSale'
import CusSelect from './cusSelect.vue'
import { DcMessage } from '@dc-platform/dc-components'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiLoseWarningParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: AddBiLoseWarningParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const selectData = (value: string) => {
  editForm.value.arkCode = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, riskLevel } = editForm.value
    const p = {
      arkCode,
      cosId,

      riskLevel
    }
    try {
      if (editForm.value.id) {
        await updateBiLoseWarning({ ...p, id: editForm.value.id })
      } else {
        await customerLossCreate(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
